import { uploadToMediaManagement } from "../functions/upload_to_MM.jsx";


export const fetchVideoFile = async ({
    bannerData,
    bannerUrl,
    animateBanner,
    defaultCampaigns,
    marketingGoals,
    targetAudience,
    vibeAndTone,
    setUploadVideoID,
    setAllGenratedVideos,
    setSelectedVideo,
    ChangeFetchVideoFileStatus,
    selectedCategory,
    campaignDescription,
    productImageUrl,
    language,
    setVideoUrl,
    setCurrentBalance,
    aspectVideoRatio,
    setSpinning,
    getToken,
    configData,
    navigate,
    notify
}) => {
    // return { video_url: false, video_id: false };
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        let jsonBody = {}
        if(animateBanner){
          if(!bannerUrl){
            notify("Please generate banner first before animating it.", "error");
            return;
          }
          else{
            if(campaignDescription !== ""){
              jsonBody = {
                  ...bannerData,
                  video_id: `Video_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                  reference_url: bannerUrl,
                  product_title: campaignDescription.split("\n").join(" ")
                }
              }
            else{
              jsonBody = {
                ...bannerData,
                video_id: `Video_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                reference_url: bannerUrl,
                product_title: ``,
              };
            }
        }}
        else{
            if(campaignDescription || productImageUrl !== ""){
              jsonBody = {
                  ...bannerData,
                  video_id: `Video_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                  reference_url: productImageUrl,
                  product_title: campaignDescription.split("\n").join(" ")
                }
            }
            else{
              jsonBody = {
                ...bannerData,
                video_id: `Video_${bannerData?.chain_name ?? ""}_${language}_${hours}_${minutes}_${seconds}`,
                reference_url: defaultCampaigns[selectedCategory].Product_image,
                product_title: `${defaultCampaigns[selectedCategory].Product_title} ${defaultCampaigns[selectedCategory].Price}. ${defaultCampaigns[selectedCategory].Description ? defaultCampaigns[selectedCategory].Description : ""}`,
              };
          }
        }
        jsonBody = {
          ...jsonBody,
          video_ratio: aspectVideoRatio,
        }

        const token = getToken();
        const res = await fetch(`${configData.DEMO_URL}/CreateVideo`, {
          method: "POST",
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonBody),
        });

        if (!res.ok) {
          setSpinning(prev => ({ ...prev, ["video"]: false }));
          let errorMessage = `Request failed (${res.status})`;

          try {
            const errorBody = await res.json();
            if (errorBody?.message) {
              errorMessage = errorBody.message;
            }
          } catch (_) {
          }

          const error = new Error(errorMessage);
          error.status = res.status;
          throw error;
        }


        const response = await res.json();
        setVideoUrl(`${response.video_url}`);
        setCurrentBalance(response.current_balance)
        setSpinning(prev => ({ ...prev, ["video"]: false }));
        ChangeFetchVideoFileStatus(false);

        const uploadVideoData = {
          videoUrl: response.video_url,
          video_id: jsonBody.video_id,
        };
        uploadToMediaManagement({
          uploadData: {"uploadVideoData": uploadVideoData},
          setUploadVideoID,
          setAllGenratedVideos,
          setSelectedVideo,
          aspectVideoRatio,
          marketingGoals,
          targetAudience,
          vibeAndTone,
          getToken,
          configData,
          notify,
        });
        return

      } catch (error) {
          if (error.status === 401 || error.status === 403) {
            setSpinning(prev => ({ ...prev, ["video"]: false }));
            navigate("/");
          } else {
            notify(error.message, "error");
            ChangeFetchVideoFileStatus(false);
          }

          setSpinning(prev => ({ ...prev, ["video"]: false }));
          ChangeFetchVideoFileStatus(false);
          return
      }
  }